// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__P5X3U","file":"styles_file__1k-2Q"};